/**
 * Platform display helpers
 * Determines which platform icon/name to show based on connected accounts
 */

import { FiFacebook, FiInstagram, FiGrid, FiAlertCircle } from 'react-icons/fi';
import { FaLinkedin } from 'react-icons/fa';

export const getPlatformDisplay = (project) => {
  if (!project) {
    return { name: 'N/A', Icon: FiAlertCircle, color: 'text-cream/40' };
  }

  const hasFacebook = !!project.associatedPageId;
  const hasInstagram = !!project.associatedInstagramId;
  const hasLinkedIn = !!project.associatedLinkedInId;

  if (hasLinkedIn && (hasFacebook || hasInstagram)) {
    return { name: 'Multi-Platform', Icon: FiGrid, color: 'text-blue-500' };
  } else if (hasLinkedIn) {
    return { name: 'LinkedIn', Icon: FaLinkedin, color: 'text-[#0077B5]' };
  } else if (hasFacebook && hasInstagram) {
    return { name: 'Meta', Icon: FiGrid, color: 'text-blue-500' };
  } else if (hasFacebook) {
    return { name: 'Facebook', Icon: FiFacebook, color: 'text-blue-500' };
  } else if (hasInstagram) {
    return { name: 'Instagram', Icon: FiInstagram, color: 'text-pink-500' };
  }

  return { name: 'N/A', Icon: FiAlertCircle, color: 'text-cream/40' };
};
